export const FacilityControllerFactory = ({
  facilityService,
}: {
  facilityService: IFacilityService;
}) => {
  const getFacilities = () => {
    return facilityService.getFacilities();
  };

  const getAllFacilities = () => {
    return facilityService.getAllFacilities();
  };

  const assignFacility = (userId: string, clinicIds: number[]) => {
    return facilityService.assignFacility({ userId, clinicIds });
  };

  const provisionCompassusClinics = () => {
    return facilityService.provisionCompassusClinics();
  };

  return {
    getFacilities,
    assignFacility,
    getAllFacilities,
    provisionCompassusClinics,
  };
};
